import _merge from 'lodash/merge';
import _pick from 'lodash/pick';
import _lowerCase from 'lodash/lowerCase';
import _reduce from 'lodash/reduce';

import Template from '@/template';
import defaultSettings from '@/product/default-settings';
import selectors from '@/product/default-selectors';

/**
 * Класс для работы с настройками Продукта
 *
 * @class
 * @memberof Product
 * @alias Product.settings
 *
 * @private
 *
 * @param {Object} settings - входные настройки.... штаа...
 *
 * @return {Null} - чот ничего не возвращает. Оо
 */
var ProductSettings = function(settings) {
  var self = this;

  self.set(defaultSettings);
  self.set(settings);

  return self;
};

/**
 * @private
 *
 * @description
 * Получаем настройки из внутреннего поля. Инициализируем его, если еще не
 * создано
 *
 * @return {Object} - настройки
 */
ProductSettings.prototype.getSettings = function($form) {
  var self = this;
  var _settings = {};

  if (!self.settings) {
    self.settings = {};
  }

  if ($form && $form.length && $form.data('set-config')) {
    var formSettins = $form.data('set-config');
    try {
      if (typeof formSettins == 'object') {
        self.set(formSettins);
      } else if (typeof formSettins == 'string') {
        self.set(JSON.parse(formSettins));
      }
    } catch (e) {
      console.log(e, $form);
    }
  }

  _settings = self.settings;

  return _settings;
};

/**
 * @private
 *
 * @description
 * Выставляем настройки, делаем немного магии. Применяем только новые настройки.
 *
 * @param {Object} newSettings - объект с новыми настройками
 *
 * @return {Null} - ничего не возвращаем... ШТААААА
 */
ProductSettings.prototype.set = function(newSettings) {
  var self = this;
  var _settings = self.getSettings();

  _merge(_settings, newSettings);

  _settings.quantity = self._getQuantityConfig(_settings);
  _settings.optionSelector = self._getOptionsConfig(_settings);
  _settings.selectors = selectors;

  return;
};

/**
 * @private
 *
 * @description
 * Группируем настройки для считалки товара
 *
 * @param {Object} settings - объект со всеми настройками
 *
 * @return {Object} - сгруппированные настройки для считалки
 */
ProductSettings.prototype._getQuantityConfig = function(settings) {
  var _quantitySettings = settings.quantity || {};
  var _picked = {};

  _picked = _pick(settings, [ 'useMax', 'withCart', 'decimal' ]);
  _merge(_quantitySettings, _picked);

  return _quantitySettings;
};

/**
 * @private
 *
 * @description
 * Группируем настройки для селектора модификаций
 *
 * @param {Object} settings - объект со всеми настройками
 *
 * @return {Object} - сгруппированные настройки для селектора
 */
ProductSettings.prototype._getOptionsConfig = function(settings) {
  var self = this;
  var _optionSelector = settings.optionSelector || {};
  var _picked = {};

  _picked = _pick(settings,
    [
      'options',
      'showVariants',
      'initOption',
      'fileUrl',
      'filtered',
      'selectUnavailable',
      'allowUnavailable',
      'hideSelect',
      'labels',
      'imagesCombineOrder'
    ]);
  _merge(_optionSelector, _picked);

  _optionSelector.fullFileUrl = self._patchFileUrl(_picked.fileUrl);


  _optionSelector.options = _reduce(_picked.options, function(_patched, templateId, _option) {
    var _isLoadedTmpl = Template.has(templateId);

    _patched[_lowerCase(_option)] =
      _isLoadedTmpl ? templateId : 'option-default';

    return _patched;
  }, {});

  _optionSelector.labels = _reduce(_picked.labels, function(_patched, _label, _option) {
    _patched[_lowerCase(_option)] = _label;

    return _patched;
  }, {});

  return _optionSelector;
};

/**
 * @private
 *
 * @description
 * Патчим комплект картинкрк из раздела "Файлы" БО до единого вида с картинками
 * товаров.
 *
 * @param {Object} fileUrl - объект с картинками. Имеет вид
 * { значение_опции: url_файла_картинки }
 *
 * @return {Object} - объект с развернутой структурой
 */
ProductSettings.prototype._patchFileUrl = function(fileUrl) {
  var _fileUrl = fileUrl;

  _fileUrl = _reduce(fileUrl, function(_result, _url, _name) {
    _result[_lowerCase(_name)] = {
      large_url: _url,
      medium_url: _url,
      original_url: _url,
      small_url: _url,
      thumb_url: _url,
    };

    return _result;
  }, {});

  return _fileUrl;
};

export default ProductSettings;
